import {ClassComponent, VnodeDOM} from 'mithril';
import app from 'flarum/forum/app';
import extractText from 'flarum/common/utils/extractText';

export default class RichTextField implements ClassComponent<any> {
    updateInterval: number = 0

    oncreate(vnode: VnodeDOM<any, this>) {
        // Similar to the post preview, refresh every 50ms if the content has changed
        let preview: string;
        this.updateInterval = setInterval(() => {
            const content = (vnode.dom.querySelector('textarea') as HTMLElement as HTMLInputElement).value;

            if (preview === content) return;

            preview = content;

            if (preview) {
                s9e.TextFormatter.preview(preview, vnode.dom.querySelector('.js-preview'));
            } else {
                const placeholder = document.createElement('P');
                placeholder.className = 'FormulaireRichPlaceholder';
                placeholder.innerText = extractText(app.translator.trans('kilowhat-formulaire.forum.rich-text.preview-placeholder'));
                const previewElement = vnode.dom.querySelector('.js-preview') as HTMLElement;
                previewElement.innerHTML = '';
                previewElement.appendChild(placeholder);
            }
        }, 50) as any;
    }

    onremove() {
        clearInterval(this.updateInterval);
    }

    view(vnode: VnodeDOM<any, this>) {
        return m('.FormulaireRich', [
            m('.FormulaireRichPreview.js-preview', {
                onclick: (event: Event) => {
                    event.preventDefault();
                    (vnode.dom.querySelector('textarea') as HTMLElement as HTMLInputElement).focus();
                },
            }),
            m('textarea.FormControl', vnode.attrs),
        ]);
    }
}
